import { render, staticRenderFns } from "./ui-arrows.vue?vue&type=template&id=021be86f&scoped=true&"
import script from "./ui-arrows.vue?vue&type=script&lang=js&"
export * from "./ui-arrows.vue?vue&type=script&lang=js&"
import style0 from "./ui-arrows.vue?vue&type=style&index=0&id=021be86f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021be86f",
  null
  
)

export default component.exports